// extracted by mini-css-extract-plugin
export var section = "templates-module--section--35Oqd";
export var head = "templates-module--head--2K_C6";
export var head_left = "templates-module--head_left--3xQdy";
export var head_right = "templates-module--head_right--ODRhC";
export var title = "templates-module--title--kGayF";
export var subtitle = "templates-module--subtitle--3RjVV";
export var btnWrap = "templates-module--btnWrap--3MXWa";
export var jsAnimInit = "templates-module--jsAnimInit--2XmkR";